import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["subCategories", "hsSoftwareFilters", "levelFilters", "useCases", "businessObjectives", "lessonType", "language", "visibleOnLoggedOutPage", "deprecationFinalDate", "visibility", "deprecationWarningDate", "deprecationCta", "deprecationMessage", "previewThumbnailSquareUrl", "previewThumbnailRectangleUrl", "pagePath"];
export function lessonToLessonCardModel(lesson) {
  const {
      subCategories,
      hsSoftwareFilters,
      levelFilters,
      useCases,
      businessObjectives,
      lessonType,
      language,
      visibleOnLoggedOutPage,
      deprecationFinalDate,
      visibility,
      deprecationWarningDate,
      deprecationCta,
      deprecationMessage,
      previewThumbnailSquareUrl,
      previewThumbnailRectangleUrl,
      pagePath
    } = lesson,
    commonProps = _objectWithoutPropertiesLoose(lesson, _excluded);
  return Object.assign({}, commonProps, {
    pagePath: pagePath || undefined,
    previewThumbnailSquareUrl: previewThumbnailSquareUrl || undefined,
    previewThumbnailRectangleUrl: previewThumbnailRectangleUrl || undefined,
    deprecationCta: deprecationCta || undefined,
    deprecationMessage: deprecationMessage || undefined,
    deprecationWarningDate: deprecationWarningDate || undefined,
    seoRelatedTrackIds: [],
    seoRelatedLessonIds: [],
    seoRelatedContent: [],
    seoProfessorIds: [],
    language: language.toUpperCase(),
    lessonType: lessonType,
    subCategories: subCategories,
    hsSoftwareFilters: hsSoftwareFilters || [],
    levelFilters: levelFilters || [],
    useCases: useCases || [],
    businessObjectives: businessObjectives || [],
    visibleOnLoggedOutPage: !!visibleOnLoggedOutPage,
    featuredHomePage: false,
    isDeprecated: Boolean(deprecationFinalDate && deprecationFinalDate < Date.now()),
    shouldShowDeprecationWarning: false,
    type: 'LESSON',
    visibility: (visibility === null || visibility === void 0 ? void 0 : visibility.toUpperCase()) || 'PUBLIC',
    // The following are optional/SEO fields, set to undefined or empty as needed
    seoBadge: undefined,
    headline: undefined,
    titleTag: undefined,
    metaDescription: undefined,
    learnings: [],
    personas: [],
    __typename: 'com.hubspot.academy.catalog.models.lesson.CatalogLessonResponse',
    previewThumbnailSquare: {},
    previewThumbnailRectangle: {},
    progress: null
  });
}